import { useContext } from 'react';
import { Box } from '@mui/material';

import SearchInput from 'Lib/muiComponents/common/SearchInput';

import LettersContext from './context';
import { NewLetterButton } from './styledComponents';

export const Header = ({ isLoading, onSearch, toggleCreate }) => {
    const { search, showForm } = useContext(LettersContext);

    if (showForm) return null;

    return (
        <Box sx={{ textAlign: 'center', px: 4 }}>
            <NewLetterButton variant="primary" onClick={toggleCreate} sx={{ float: 'left', my: 4 }}>
                Create a New Letter
            </NewLetterButton>
            <SearchInput
                label="Search"
                value={search}
                placeholder="Search Letters"
                isLoading={isLoading}
                onChange={value => {
                    onSearch(value);
                }}
            />
        </Box>
    );
};
